/**
 * Sabine — centralized identity constants for Salesably's AI sales enablement agent.
 * Import from here whenever you reference Sabine's name, avatar, or UI copy
 * so all three chat experiences (Playbook, Reports, Result Coach) stay in sync.
 */

export const SABINE_NAME = "Sabine";
export const SABINE_AVATAR_SRC = "/sabine/sabine-v2-insight-2.jpg";
// The "direct" head-on portrait — where she leads a row (the chat's header,
// the Ask pill). Kept separate so the in-chat message avatars keep the
// insight pose.
export const SABINE_DIRECT_AVATAR_SRC = "/sabine/sabine-direct.jpg";
export const SABINE_TITLE = "Ask Sabine";
export const SABINE_SUBTITLE = "Your AI sales enablement agent";
export const SABINE_ANNOUNCEMENT_TITLE = "Meet Sabine";

/**
 * The output cap on every reply Sabine writes (result coach, reports chat,
 * Home chat, email). One number: three replies stopped mid-sentence at
 * 1,100–1,400 tokens because a markdown table over thirty learners or a
 * per-criterion feedback table needs about 1,600 (SAL-3205). A reply that
 * reaches this cap is a prompt problem, not a reason to raise it per site.
 */
export const SABINE_REPLY_MAX_OUTPUT_TOKENS = 2400;
